import isValidLink from 'util/isValidLink';

export default function sanitizeLink(url: string): string | null {
  if (url.indexOf(':') === -1) {
    url = `https://${url}`;
  }
  if (!isValidLink(url)) {
    return null;
  }
  return url;
}
